<script setup lang="ts">
import { useClient } from '@/stores/client';

type NavItem = {
  id: string,
  label: string,
  icon: string,
  to: string,
  count?: number,
};

const route = useRoute();
const client = useClient();
const favoritesCount = useState<number>('favoritesCount', () => 0);
const feedDetailsOpen = useState<boolean>('feedDetailsDrawerOpen', () => false);
const videoRecorderOpen = useState<boolean>('videoRecorderOpen', () => false);

const items = computed<NavItem[]>(() => {
  const companyId = client.getActiveCompany?.id;

  return [
    { id: 'feed', label: 'Лента', icon: 'tabler:layout-grid-filled', to: '/feed' },
    { id: 'favorites', label: 'Избранное', icon: 'tabler:heart-filled', to: '/favorites', count: favoritesCount.value },
    { id: 'chat', label: 'Чат', icon: 'tabler:message-filled', to: '/chats' },
    { id: 'responses', label: 'Отклики', icon: 'tabler:target-arrow', to: companyId ? `/company/${companyId}/vacancies` : '/applicant/responses' },
    { id: 'profile', label: 'Профиль', icon: 'tabler:user-filled', to: '/profile' },
  ];
});

function isActive(item: NavItem): boolean {
  if (item.id === 'feed') {
    return route.path.startsWith('/feed');
  }
  if (item.id === 'profile') {
    return route.path === item.to
      || route.path.startsWith(`${item.to}/`)
      || route.path.startsWith('/notifications')
      || route.path.startsWith('/profile/settings');
  }
  return route.path === item.to || route.path.startsWith(`${item.to}/`);
}
</script>

<template>
  <nav
    class="app-mobile-navbar fixed inset-x-0 bottom-0 z-50 flex w-full items-start justify-between border-t border-border bg-background px-6 pb-[calc(0.5rem+env(safe-area-inset-bottom,0px))] pt-2 text-foreground md:hidden"
    :class="(feedDetailsOpen || videoRecorderOpen) && 'max-[767.98px]:hidden'"
  >
    <NuxtLink
      v-for="item in items"
      :key="item.id"
      :to="item.to"
      class="relative flex flex-1 flex-col items-center justify-start gap-0.5 rounded-lg p-0.5 text-muted-foreground outline-none transition-colors [-webkit-tap-highlight-color:transparent] focus-visible:ring-2 focus-visible:ring-ring data-[active=true]:text-primary"
      :data-active="isActive(item) ? 'true' : 'false'"
      :aria-current="isActive(item) ? 'page' : undefined"
    >
      <Icon
        :name="item.icon"
        class="size-6 shrink-0"
      />
      <span
        v-if="item.count"
        class="absolute left-1/2 top-0 ml-1.5 min-w-4 -translate-y-1/4 rounded-full bg-primary px-1 text-center text-[9px] font-semibold leading-4 text-primary-foreground"
      >
        {{ item.count > 9 ? '9+' : item.count }}
      </span>
      <span class="m-0 block max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-center text-[10px] font-semibold leading-3.5 tracking-[-0.24px]">
        {{ item.label }}
      </span>
    </NuxtLink>
  </nav>
</template>
